module.exports = __webpack_public_path__ + "6f17a98cb9a52368cbfcd5e3d3759e9c.png";